import { render } from "./EditMultiplePoints.vue?vue&type=template&id=43985c82"
import script from "./EditMultiplePoints.vue?vue&type=script&lang=js"
export * from "./EditMultiplePoints.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__